import firebaseApp from '../../../../services/firebaseService';
import { BasicBaseHelper, IBasicBaseClass } from '../../base';

export interface IPumpingStationFlowmeterPulse extends IBasicBaseClass {
    description : string;

    isActive : boolean;
}

export default class PumpingStationFlowmeterPulseHelper extends BasicBaseHelper {
    public static readonly COLLECTION_NAME = 'pumping_station_flowmeter_pulse';

    private static converter : firebase.firestore.FirestoreDataConverter<IPumpingStationFlowmeterPulse> = {
        fromFirestore: (snapshot) => {
            return PumpingStationFlowmeterPulseHelper.fromFirestoreDocument(snapshot);
        },
        toFirestore: (data : IPumpingStationFlowmeterPulse) : firebase.firestore.DocumentData => {
            return PumpingStationFlowmeterPulseHelper.toFirestoreDocument(data);
        },
    };

    public static fromFirestoreDocument(snapshot : firebase.firestore.DocumentSnapshot) : IPumpingStationFlowmeterPulse {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!snapshot.exists || !result || !data) throw new Error(`Document does not exist! ${snapshot.id}`);
        return {
            ...data as IPumpingStationFlowmeterPulse,
            ...result,
        };
    }

    public static toFirestoreDocument(data : IPumpingStationFlowmeterPulse) {
        const result = super.toFirestore(data);
        const { id: _id, ...rest } = data;

        return {
            ...rest,
            ...result,
        };
    }

    public static doc(id ?: string) {
        if (!id) {
            return firebaseApp.firestore().collection(PumpingStationFlowmeterPulseHelper.COLLECTION_NAME).withConverter(PumpingStationFlowmeterPulseHelper.converter).doc();
        }

        return firebaseApp.firestore().collection(PumpingStationFlowmeterPulseHelper.COLLECTION_NAME).withConverter(PumpingStationFlowmeterPulseHelper.converter).doc(id);
    }

    public static save(company : IPumpingStationFlowmeterPulse) {
        return PumpingStationFlowmeterPulseHelper.doc(company.id).set(company, {
            merge: true,
        });
    }
    
    public static collection() {
        return firebaseApp
            .firestore()
            .collection(PumpingStationFlowmeterPulseHelper.COLLECTION_NAME)
            .withConverter(PumpingStationFlowmeterPulseHelper.converter);
    }
}